import { Action } from '../../../action';
import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { getCatchError } from '../../../getCatchError';

const setPostAuthorization = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_AUTHORIZATION
            });

            if (data.status === 'success') {
                localStorage.setItem('token', data.token);
                dispatch(Action.SetAuthorizeAction(true))
                window.location.replace(window.location.origin);
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostAuthorization as SetPostAuthorization
}